module.exports = __webpack_public_path__ + "static/painting-d179d5510acc4e1c68200c214a4c9674.png";